import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Label,
  Textarea,
} from "@b2b/ui-components";

type RejectProductReasonDialogProps = {
  open: boolean;
  title: string;
  description: string;
  reason: string;
  onReasonChange: (value: string) => void;
  onClose: () => void;
  onConfirm: () => void;
  confirmLabel?: string;
  loading?: boolean;
  textareaId?: string;
  placeholder?: string;
};

export function RejectProductReasonDialog({
  open,
  title,
  description,
  reason,
  onReasonChange,
  onClose,
  onConfirm,
  confirmLabel = "Reject product",
  loading = false,
  textareaId = "reject-reason",
  placeholder = "Explain what the seller should fix or change…",
}: RejectProductReasonDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && !loading && onClose()}>
      <DialogContent className="sm:max-w-md bg-white" showCloseButton={!loading}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">{description}</p>
        <div className="space-y-2">
          <Label htmlFor={textareaId}>Reason</Label>
          <Textarea
            id={textareaId}
            value={reason}
            onChange={(e) => onReasonChange(e.target.value)}
            placeholder={placeholder}
            rows={4}
            disabled={loading}
            className="resize-y min-h-[100px]"
          />
        </div>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button type="button" variant="outline" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" onClick={onConfirm} disabled={loading}>
            {loading ? "Rejecting…" : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
